import axiosInstance from "../../../api/axiosInstance";

export default {
  namespaced: true,
  state: {
    transactions: [],
  },
  mutations: {
    setTransactionHistory(state, data) {
      state.transactions = data;
    },
  },
  getters: {
    transactions: (state) => state.transactions,
  },
  actions: {
    getPaymentToken() {
      return axiosInstance
        .get("/payment_token")
        .then((r) => r)
        .catch((e) => e.response);
    },
    updatePaymentMethod({}, payload) {
      return axiosInstance
        .put("/user_subscriptions/update_payment_method", payload)
        .then((res) => {
          return res;
        })
        .catch((e) => e.response);
    },
    loadTransactions({ commit }) {
      return axiosInstance
        .get("/load_transactions")
        .then((res) => {
          commit("setTransactionHistory", res.data);
          return res;
        })
        .catch((err) => err.response);
    },
    submitPayment({ commit }, payload) {
      return axiosInstance
        .post("/payments", { payment: { ...payload } })
        .then((res) => {
          // commit("setReceiptInfo", res.data);
          return res;
        })
        .catch((e) => e.response);
    },
    loadDiscountCode({}, { discountCode, planId, profileCount }) {
      return axiosInstance
        .get("/discount_code", {
          params: {
            discount_code: discountCode,
            plan_id: planId,
            student_limit: profileCount,
          },
        })
        .then((res) => res)
        .catch((e) => e.response);
    },
  },
};
